
/**
 * @sveltech/routify 1.9.9
 * File generated Tue Apr 09 2024 14:01:50 GMT+0200 (Mitteleuropäische Sommerzeit)
 */

export const __version = "1.9.9"
export const __timestamp = "2024-04-09T12:01:50.445Z"

//buildRoutes
import { buildClientTree } from "@sveltech/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "name": "root",
  "filepath": "/",
  "root": true,
  "ownMeta": {
    "bundle": true,
    "children": [
      {
        "title": "Facebook",
        "path": "//facebook.com/TotalEnergiesBelgium/",
        "icon": "/images/social-icons/facebook.png",
        "showInSocialLinks": true
      },
      {
        "title": "Twitter",
        "path": "//twitter.com/TotalEnergiesBE",
        "icon": "/images/social-icons/twitter.png",
        "showInSocialLinks": true
      },
      {
        "title": "LinkedIn",
        "path": "//linkedin.com/company/totalenergies/",
        "icon": "/images/social-icons/linkedin.png",
        "showInSocialLinks": true
      },
      {
        "title": "Instagram",
        "path": "//instagram.com/totalenergies_be",
        "icon": "/images/social-icons/instagram.png",
        "showInSocialLinks": true
      },
      {
        "title": "YouTube",
        "path": "//youtube.com/channel/UCXc0jPCckEICHgJlW-HKsRQ",
        "icon": "/images/social-icons/youtube.png",
        "showInSocialLinks": true
      }
    ]
  },
  "absolutePath": "src/pages",
  "children": [
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": true,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/_fallback",
      "id": "__fallback",
      "component": () => import('./_.js').then(m => m.__fallback)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": true,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/",
      "id": "__layout",
      "component": () => import('./_.js').then(m => m.__layout)
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": true,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/login",
          "id": "_login__reset",
          "component": () => import('./_.js').then(m => m._login__reset)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/login/index",
          "id": "_login_index",
          "component": () => import('./_.js').then(m => m._login_index)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/login"
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": true,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/logout",
          "id": "_logout__reset",
          "component": () => import('./_.js').then(m => m._logout__reset)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/logout/index",
          "id": "_logout_index",
          "component": () => import('./_.js').then(m => m._logout_index)
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/logout"
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": true,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {
        "title": "Home",
        "index": 1,
        "showInNavigation": true
      },
      "meta": {
        "title": "Home",
        "index": 1,
        "showInNavigation": true,
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/index",
      "id": "_index",
      "component": () => import('./_.js').then(m => m._index)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {
        "title": "Terms of service",
        "index": 1,
        "showInFooter": true
      },
      "meta": {
        "title": "Terms of service",
        "index": 1,
        "showInFooter": true,
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/terms-of-service",
      "id": "_termsOfService",
      "component": () => import('./_.js').then(m => m._termsOfService)
    },
    {
      "isFile": false,
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": true,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin",
          "id": "_admin__layout",
          "component": () => import('./_.js').then(m => m._admin__layout)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": true,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {},
          "meta": {
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/index",
          "id": "_admin_index",
          "component": () => import('./_.js').then(m => m._admin_index)
        },
        {
          "isFile": true,
          "isDir": false,
          "ext": "svelte",
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": true,
          "ownMeta": {
            "title": "Status",
            "index": 1,
            "showInNavigation": true,
            "guards": [
              "canShowSystemStatus"
            ]
          },
          "meta": {
            "title": "Status",
            "index": 1,
            "showInNavigation": true,
            "guards": [
              "canShowSystemStatus"
            ],
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/status",
          "id": "_admin_status",
          "component": () => import('./_.js').then(m => m._admin_status)
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": true,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/users",
              "id": "_admin_users__layout",
              "component": () => import('./_.js').then(m => m._admin_users__layout)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/users/index",
              "id": "_admin_users_index",
              "component": () => import('./_.js').then(m => m._admin_users_index)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {
                "title": "User list",
                "index": 1,
                "showInNavigation": true
              },
              "meta": {
                "title": "User list",
                "index": 1,
                "showInNavigation": true,
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/users/list",
              "id": "_admin_users_list",
              "component": () => import('./_.js').then(m => m._admin_users_list)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {
                "title": "User details",
                "index": 2,
                "showInNavigation": false
              },
              "meta": {
                "title": "User details",
                "index": 2,
                "showInNavigation": false,
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/users/:id",
              "id": "_admin_users__id",
              "component": () => import('./_.js').then(m => m._admin_users__id)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {
            "title": "Users",
            "index": 2,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canManageUsers"
            ]
          },
          "meta": {
            "title": "Users",
            "index": 2,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canManageUsers"
            ],
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/users"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": true,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/address",
              "id": "_admin_address__layout",
              "component": () => import('./_.js').then(m => m._admin_address__layout)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/address/index",
              "id": "_admin_address_index",
              "component": () => import('./_.js').then(m => m._admin_address_index)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {
                "title": "Address list",
                "index": 1,
                "showInNavigation": true
              },
              "meta": {
                "title": "Address list",
                "index": 1,
                "showInNavigation": true,
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/address/list",
              "id": "_admin_address_list",
              "component": () => import('./_.js').then(m => m._admin_address_list)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {
                "title": "Address details",
                "index": 3,
                "showInNavigation": false
              },
              "meta": {
                "title": "Address details",
                "index": 3,
                "showInNavigation": false,
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/address/:id",
              "id": "_admin_address__id",
              "component": () => import('./_.js').then(m => m._admin_address__id)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {
            "title": "Billing addresses",
            "index": 3,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canManageCustomers"
            ]
          },
          "meta": {
            "title": "Billing addresses",
            "index": 3,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canManageCustomers"
            ],
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/address"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": true,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/dealers",
              "id": "_admin_dealers__layout",
              "component": () => import('./_.js').then(m => m._admin_dealers__layout)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/dealers/index",
              "id": "_admin_dealers_index",
              "component": () => import('./_.js').then(m => m._admin_dealers_index)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {
                "title": "Dealers",
                "index": 1,
                "showInNavigation": true
              },
              "meta": {
                "title": "Dealers",
                "index": 1,
                "showInNavigation": true,
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/dealers/create",
              "id": "_admin_dealers_create",
              "component": () => import('./_.js').then(m => m._admin_dealers_create)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {
            "title": "Dealers",
            "index": 4,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canManageDealers"
            ]
          },
          "meta": {
            "title": "Dealers",
            "index": 4,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canManageDealers"
            ],
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/dealers"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": true,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/tasks",
              "id": "_admin_tasks__layout",
              "component": () => import('./_.js').then(m => m._admin_tasks__layout)
            },
            {
              "isFile": false,
              "isDir": true,
              "ext": "",
              "children": [
                {
                  "isFile": true,
                  "isDir": false,
                  "ext": "svelte",
                  "isLayout": false,
                  "isReset": false,
                  "isIndex": false,
                  "isFallback": false,
                  "isPage": true,
                  "ownMeta": {
                    "showInNavigation": false,
                    "title": "Task details",
                    "index": 2
                  },
                  "meta": {
                    "showInNavigation": false,
                    "title": "Task details",
                    "index": 2,
                    "preload": false,
                    "prerender": true,
                    "precache-order": false,
                    "precache-proximity": true,
                    "recursive": true,
                    "$$bundleId": "_.js"
                  },
                  "path": "/admin/tasks/detail/:id",
                  "id": "_admin_tasks_detail__id",
                  "component": () => import('./_.js').then(m => m._admin_tasks_detail__id)
                }
              ],
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/tasks/detail"
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/tasks/index",
              "id": "_admin_tasks_index",
              "component": () => import('./_.js').then(m => m._admin_tasks_index)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {
                "title": "Tasks",
                "index": 1,
                "showInNavigation": true
              },
              "meta": {
                "title": "Tasks",
                "index": 1,
                "showInNavigation": true,
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/tasks/list",
              "id": "_admin_tasks_list",
              "component": () => import('./_.js').then(m => m._admin_tasks_list)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {
            "title": "Tasks",
            "index": 5,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canManageTasks"
            ]
          },
          "meta": {
            "title": "Tasks",
            "index": 5,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canManageTasks"
            ],
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/tasks"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": true,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/email",
              "id": "_admin_email__layout",
              "component": () => import('./_.js').then(m => m._admin_email__layout)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/email/index",
              "id": "_admin_email_index",
              "component": () => import('./_.js').then(m => m._admin_email_index)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {
                "title": "E-mail",
                "index": 1,
                "showInNavigation": true
              },
              "meta": {
                "title": "E-mail",
                "index": 1,
                "showInNavigation": true,
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/email/send",
              "id": "_admin_email_send",
              "component": () => import('./_.js').then(m => m._admin_email_send)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {
            "title": "E-mail",
            "index": 6,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canSendEmail"
            ]
          },
          "meta": {
            "title": "E-mail",
            "index": 6,
            "showInNavigation": true,
            "flat": true,
            "guards": [
              "canSendEmail"
            ],
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/email"
        },
        {
          "isFile": false,
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": true,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": false,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/statistics",
              "id": "_admin_statistics__layout",
              "component": () => import('./_.js').then(m => m._admin_statistics__layout)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": true,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {},
              "meta": {
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/statistics/index",
              "id": "_admin_statistics_index",
              "component": () => import('./_.js').then(m => m._admin_statistics_index)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {
                "title": "Overview",
                "index": 1,
                "showInNavigation": true
              },
              "meta": {
                "title": "Overview",
                "index": 1,
                "showInNavigation": true,
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/statistics/overview",
              "id": "_admin_statistics_overview",
              "component": () => import('./_.js').then(m => m._admin_statistics_overview)
            },
            {
              "isFile": true,
              "isDir": false,
              "ext": "svelte",
              "isLayout": false,
              "isReset": false,
              "isIndex": false,
              "isFallback": false,
              "isPage": true,
              "ownMeta": {
                "title": "Invoices",
                "index": 2,
                "showInNavigation": true
              },
              "meta": {
                "title": "Invoices",
                "index": 2,
                "showInNavigation": true,
                "preload": false,
                "prerender": true,
                "precache-order": false,
                "precache-proximity": true,
                "recursive": true,
                "$$bundleId": "_.js"
              },
              "path": "/admin/statistics/invoices",
              "id": "_admin_statistics_invoices",
              "component": () => import('./_.js').then(m => m._admin_statistics_invoices)
            }
          ],
          "isLayout": false,
          "isReset": false,
          "isIndex": false,
          "isFallback": false,
          "isPage": false,
          "ownMeta": {
            "title": "Statistics",
            "index": 7,
            "showInNavigation": true,
            "guards": [
              "canShowStatistics"
            ]
          },
          "meta": {
            "title": "Statistics",
            "index": 7,
            "showInNavigation": true,
            "guards": [
              "canShowStatistics"
            ],
            "preload": false,
            "prerender": true,
            "precache-order": false,
            "precache-proximity": true,
            "recursive": true,
            "$$bundleId": "_.js"
          },
          "path": "/admin/statistics"
        }
      ],
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": false,
      "ownMeta": {
        "title": "Admin",
        "index": 2,
        "showInNavigation": true,
        "flat": true,
        "guards": [
          "isLoggedIn"
        ]
      },
      "meta": {
        "title": "Admin",
        "index": 2,
        "showInNavigation": true,
        "flat": true,
        "guards": [
          "isLoggedIn"
        ],
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/admin"
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {
        "title": "Personal data & cookies",
        "index": 2,
        "showInFooter": true
      },
      "meta": {
        "title": "Personal data & cookies",
        "index": 2,
        "showInFooter": true,
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/personal-data-and-cookies",
      "id": "_personalDataAndCookies",
      "component": () => import('./_.js').then(m => m._personalDataAndCookies)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {
        "title": "Sitemap",
        "index": 3,
        "showInFooter": false
      },
      "meta": {
        "title": "Sitemap",
        "index": 3,
        "showInFooter": false,
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/sitemap",
      "id": "_sitemap",
      "component": () => import('./_.js').then(m => m._sitemap)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {
        "title": "General conditions of sale",
        "index": 5,
        "showInFooter": true
      },
      "meta": {
        "title": "General conditions of sale",
        "index": 5,
        "showInFooter": true,
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/conditions-of-sale",
      "id": "_conditionsOfSale",
      "component": () => import('./_.js').then(m => m._conditionsOfSale)
    },
    {
      "isFile": true,
      "isDir": false,
      "ext": "svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {
        "title": "All our sites",
        "index": 6,
        "showInFooter": true
      },
      "meta": {
        "title": "All our sites",
        "index": 6,
        "showInFooter": true,
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true,
        "$$bundleId": "_.js"
      },
      "path": "/all-our-sites",
      "id": "_allOurSites",
      "component": () => import('./_.js').then(m => m._allOurSites)
    }
  ],
  "isLayout": false,
  "isReset": false,
  "isIndex": false,
  "isFallback": false,
  "meta": {
    "bundle": true,
    "children": [
      {
        "title": "Facebook",
        "path": "//facebook.com/TotalEnergiesBelgium/",
        "icon": "/images/social-icons/facebook.png",
        "showInSocialLinks": true
      },
      {
        "title": "Twitter",
        "path": "//twitter.com/TotalEnergiesBE",
        "icon": "/images/social-icons/twitter.png",
        "showInSocialLinks": true
      },
      {
        "title": "LinkedIn",
        "path": "//linkedin.com/company/totalenergies/",
        "icon": "/images/social-icons/linkedin.png",
        "showInSocialLinks": true
      },
      {
        "title": "Instagram",
        "path": "//instagram.com/totalenergies_be",
        "icon": "/images/social-icons/instagram.png",
        "showInSocialLinks": true
      },
      {
        "title": "YouTube",
        "path": "//youtube.com/channel/UCXc0jPCckEICHgJlW-HKsRQ",
        "icon": "/images/social-icons/youtube.png",
        "showInSocialLinks": true
      }
    ],
    "preload": false,
    "prerender": true,
    "precache-order": false,
    "precache-proximity": true,
    "recursive": true,
    "$$bundleId": "_.js"
  },
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

